import ua from '@tencent/docs-user-agent';
import { network } from '@tencent/netcheck';
import { TitleBarFeature } from './titlebar-feature';
import { Events, TitlebarKey } from '@tencent/docs-titlebar-service';
import { Controller, Titlebar, skipWithDefault, EventEmitter, TitlebarService, InjectorService } from '@tencent/workbench';
import { TITLEBAR_ITEMS } from './config';
import DocsConfig from '@tencent/docs-config';
import { getQuery } from 'sutils';
import { ToggleFeature } from '@framework/workbench/ui/toggle/toggle-feature';
import LocalFileSaveFeature from '@framework/workbench/ui/titlebar/features/local-file-save-feature';
import { IMMERSIVE_TOGGLE } from '@framework/workbench/ui/toggle/config';
import { TitleBarConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import './titlebar.less';

const appConfigInstance = DocsConfig.getInstance();

@Controller({
    titlebarItems: TITLEBAR_ITEMS,
})
export class TitleBarController {
    private localCanSave = false;

    public constructor(
        private readonly titlBarFeature: TitleBarFeature,
        private readonly toggleFeature: ToggleFeature,
        private readonly localSaveFeature: LocalFileSaveFeature,
        private eventEmitter: EventEmitter,
    ) {
        this.titlBarFeature.initTitlebarExtension();
        this.titlBarFeature.updateSaveTips();
        this.initListener();
    }

    @Titlebar(TitlebarKey.LOCAL_FILE_TRANSFER, 'onClick')
    public onClickLocalFileTransfer(): void {
        this.localSaveFeature.handleClickSave();
    }

    @Titlebar(TitlebarKey.LOCAL_FILE_SAVE, 'onClick')
    @Titlebar(TitlebarKey.DRIVE_FILE_SAVE, 'onClick')
    public onClickLocalSave(): void {
        this.localSaveFeature.handleClickSave();
    }

    @Titlebar(TitlebarKey.AUTH, 'onClick')
    public onClickAuth(): void {
        this.titlBarFeature.getAppServices().viewableServiceLayer?.rightSideBarService.hide();
    }

    @Titlebar(TitlebarKey.SAVE_TIPS, 'onClick')
    public onClickSaveTips(): void {
        // 本地编辑保存提示不可点击
        if (ENV.IS_PC_LOCAL_EDIT) {
            return;
        }
        tdw({
            opername: 'doc_menubar',
            module: 'autosave_hyperlinks',
            action: 'click',
        });
        if (!this.titlBarFeature.getAppServices().editableServiceLayer?.historyManager.isShowHistoryPanel) {
            this.titlBarFeature.getAppServices().editableServiceLayer?.historyManager.show();
        }
    }

    // @Titlebar(TitlebarKey.LOCAL_FILE_UPLOAD, 'onClick')
    // public onClickLocalUpload(): void {
    //     this.localSaveFeature.handleClickSave();
    // }

    // 针对titlebar组件里savetips的显隐控制(本地编辑场景不隐藏)
    @Titlebar(TitlebarKey.SAVE_TIPS, 'shouldHide')
    public hideSaveTips(): boolean {
        const { readable, editable } = SlideDataServices.PrivilegeManager() ?? {};
        const isReadOnly = readable && !editable;
        return !ENV.IS_PC_LOCAL_EDIT && (isReadOnly || this.titlBarFeature.isMasterEditType);
    }

    @Titlebar(TitlebarKey.EDIT_MENU, 'shouldHide')
    public hideEditMenu(): boolean {
        return true;
    }

    // @Titlebar(TitlebarKey.LOCAL_FILE_SAVE, 'shouldHide')
    // public hideLocalFileUpload(): boolean {
    //     return this.titlBarFeature.hasCGlobalPadId;
    // }

    @Titlebar(TitlebarKey.PRESENTATION, 'shouldHide')
    public hidePlayMenu(): boolean {
        return !appConfigInstance.getConfig(TitleBarConfig.playAction);
    }

    @Titlebar(TitlebarKey.TENCENT_MEETING, 'shouldHide')
    public hideMeetingMenu(): boolean {
        return !(ua.isTencentMeeting && (getQuery('login') === 'speaker'));
    }

    @Titlebar(TitlebarKey.TOOLBAR_MODE, 'shouldHide')
    public hideModeBtn(): boolean {
        const toolbarMode = this.toggleFeature.getToolbarMode();
        return toolbarMode !== IMMERSIVE_TOGGLE || this.toggleFeature.shouldHideToolbarMode();
    }

    // @Titlebar(TitleBarKey.LOCAL_SYNC, 'shouldHide')
    // public hideLocalSync(): boolean {
    //     return !ENV.IS_PC_LOCAL_EDIT && this.titlBarFeature.isShowLocalSync;
    // }

    @Titlebar(TitlebarKey.COLLECT, 'shouldDisabled')
    public disableCollect(): boolean {
        return !network.isOnline;
    }

    @Titlebar(TitlebarKey.MOVE, 'shouldDisabled')
    public disableMove(): boolean {
        return !network.isOnline;
    }

    @Titlebar(TitlebarKey.LOCAL_FILE_SAVE, 'shouldDisabled')
    @skipWithDefault(true)
    public localShouldDisabled(): boolean {
        return !this.localCanSave;
    }

    private initListener() {
        this.eventEmitter.listen(Events.LOCAL_EDIT_CHANGED, () => {
            this.localCanSave = true;
            InjectorService.get(TitlebarService).$forceUpdate();
        });
        this.eventEmitter.listen(Events.LOCAL_FILE_SAVE_END, () => {
            this.localCanSave = false;
            InjectorService.get(TitlebarService).$forceUpdate();
        });
    }
}
